import React, { Component } from "react";
import { BrowserRouter as Router, Route, Redirect } from "react-router-dom";
import NodeAuth from "node-auth-api";

import logo from "./logo.svg";
import "./App.css";
import Header from "./components/common/Header/Header";
import Sidebar from "./components/common/Sidebar/Sidebar";
import Content from "./components/common/Content/Content";
import Login from "./components/Login/Login";
import { Snackbar, MuiThemeProvider, createMuiTheme } from "@material-ui/core";
import Dashboard from "./components/Dashboard/Dashboard";

const theme = createMuiTheme({
  palette: {
      primary: {
        main: "#1976d2"
      },
      secondary: {
        main: '#0d47a1'
      }
    },
});

const PrivateRoute = ({component: Component, ...rest}) => {
  return <Route {...rest} render={props => {
    if(NodeAuth.User.isLoggedIn("user")) return <Component {...props} route={rest.route} />
    
    return <Redirect to={{pathname: "/", state: { from: props.location }}} />
  }} />
}
class App extends Component {
  state = {
    userAuthenticated: false,
  };

  componentDidMount() {}

  render() {
    return (
      <MuiThemeProvider theme={theme}>
        <Router>
          <>
            <Route path="/" exact component={Login} />
            <PrivateRoute path="/dashboard" exact component={Dashboard}/>
            <PrivateRoute path="/dashboard/tickets" exact component={Dashboard} route="tickets"/>
          </>
        </Router>
      </MuiThemeProvider>
    )
  }
}

export default App;
